<template>
  <div class="course-content">
    <div class="course-header">
      <div class="header-content">
        <div class="header-left">
          <div class="level-section">
            <div class="level-info">
              <!-- <h1 class="course-title">{{ currentCourse.name }}</h1> -->
              <div class="level-text">{{ currentCourse.level || '未知等级' }}</div>
            </div>
          </div>
        </div>
        <div class="header-right">
          <div class="stats-cards">
            <div class="stat-card">
              <div class="stat-number">{{ currentCourse.videos ? currentCourse.videos.length : 0 }}</div>
              <div class="stat-label">共有课程</div>
            </div>
            <div class="stat-card">
                          <div class="stat-number">{{ currentCourse.videos ? currentCourse.videos.filter(video => video.unlocked).length : 0 }}</div>
            <div class="stat-label">已解锁</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 视频列表加载状态 -->
    <div v-if="!currentCourse.videos || currentCourse.videos.length === 0" class="loading-state">
      <i class="el-icon-loading"></i>
      <p>正在加载视频列表...</p>
    </div>
    
    <div v-else class="video-list">
      <el-card 
        v-for="(video, idx) in currentCourse.videos" 
        :key="video.id" 
        class="video-card" 
        :class="{ 'video-locked': !isVideoUnlocked(idx) }"
        :style="{ cursor: isVideoUnlocked(idx) ? 'pointer' : 'not-allowed', opacity: isVideoUnlocked(idx) ? 1 : 0.5 }"
        @click.native="handleVideoClick(idx, video.id)"
      >
        <div class="video-card-content">
          <div class="video-thumb-container">
          <img :src="video.img" class="video-thumb" />
          <div class="video-overlay">
            <i class="el-icon-video-play"></i>
            </div>
          </div>
          <div class="video-info">
            <div class="video-title">{{ video.title }}</div>
            <div class="video-meta">
              <!-- <span class="duration">
                <i class="el-icon-time"></i>
                {{ video.duration || '15:30' }}
              </span> -->
              <span v-if="video.unlocked" style="color: #52c41a; margin-left: 10px;">
                <i class="el-icon-check"></i> 已解锁
              </span>
            </div>
          </div>
        </div>
      </el-card>
    </div>
    
    <div class="test-section">
      <div class="test-header">
        <h3>
          <i class="el-icon-edit"></i>
          课程测试
        </h3>
        <p>完成所有视频学习后，可进行课程测试</p>
        <div class="exam-notice">
          <i class="el-icon-warning"></i>
          <span>本次考试共有3次机会。若3次均未达到80分的合格标准，考试通道将被锁定，无法再次参加。</span>
        </div>
      </div>
      <div class="test-card">
        <div class="test-info">
          <div class="test-icon">
            <i class="el-icon-document-checked"></i>
          </div>
          <div class="test-details">
            <h4>{{ currentCourse.name || currentCourse.level || '课程' }}测试</h4>
            <p>测试您对课程内容的掌握程度</p>
            <!-- <div class="test-meta">
              <span><i class="el-icon-question"></i> 20道题目</span>
              <span><i class="el-icon-time"></i> 30分钟</span>
              <span><i class="el-icon-trophy"></i> 60分及格</span>
            </div> -->
          </div>
        </div>
        <el-button type="primary" size="medium" :disabled="!canStartTest" @click="startTest">
          开始测试
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CourseContent',
  props: {
    currentCourse: {
      type: Object,
      required: true
    },
    // 添加课程类型参数，用于获取分类ID
    courseType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // 移除watchedList，现在使用API返回的unlocked字段
      courseCategories: [],
      // 从 /api.php/v1.video/lists?cid= 接口读取的考试解锁状态
      examUnlockFromApi: false
    }
  },
  watch: {
    // 当课程ID变化时，重新获取考试解锁状态
    'currentCourse.cid': {
      immediate: true,
      handler(newCid) {
        if (newCid) {
          this.loadExamUnlockStatus(newCid)
        } else {
          this.examUnlockFromApi = false
        }
      }
    }
  },
  computed: {
    allWatched() {
      // 检查所有视频是否都已解锁
      if (!this.currentCourse || !this.currentCourse.videos || !Array.isArray(this.currentCourse.videos)) {
        return false;
      }
      return this.currentCourse.videos.every(video => video.unlocked)
    },
    examUnlocked() {
      // 从父级传入的 currentCourse 中读取测试解锁权限
      if (!this.currentCourse) return false
      const cid = this.currentCourse.cid
      const testMap = this.currentCourse.test
      if (!cid || !testMap) return false
      return testMap[cid] === true
    },
    canStartTest() {
      // 只需要所有视频解锁即可开始测试
      return this.allWatched
    }
  },
  methods: {
    isVideoUnlocked(idx) {
      // 使用API返回的unlocked字段
      if (!this.currentCourse || !this.currentCourse.videos || !Array.isArray(this.currentCourse.videos)) {
        return false;
      }
      if (idx >= 0 && idx < this.currentCourse.videos.length) {
        return this.currentCourse.videos[idx].unlocked;
      }
      return false;
    },
    handleVideoClick(idx, videoId) {
      if (!this.isVideoUnlocked(idx)) return
      this.goToVideo(videoId)
    },
    goToVideo(videoId) {
      // 获取课程类型
      const courseType = this.currentCourse.courseType || this.currentCourse.level || 'unknown'
      
      // 直接通过路由跳转，传递课程类型和视频ID
      this.$router.push({
        path: '/learning',
        query: {
          courseType: courseType,
          videoId: videoId
        }
      })
    },
    
    // 读取考试解锁状态：/api.php/v1.video/lists?cid=
    async loadExamUnlockStatus(cid) {
      try {
        const { get } = await import('@/common/request');
        const response = await get(`/api.php/v1.video/lists?cid=${cid}`)
        if (response && response.data && response.data.code === 0) {
          const data = response.data.data || {}
          const examArr = Array.isArray(data.exam) ? data.exam : []
          // 当 exam 中存在任意 unlock === 1 的项时视为解锁（无需匹配 cid）
          const unlocked = examArr.some(item => Number(item.unlock) === 1)
          this.examUnlockFromApi = unlocked
        } else {
          this.examUnlockFromApi = false
        }
      } catch (error) {
        console.error('获取考试解锁状态失败:', error)
        this.examUnlockFromApi = false
      }
    },

    // 加载课程分类
    async loadCourseCategories() {
      if (this.courseCategories.length > 0) {
        return;
      }
      
      try {
        const { get } = await import('@/common/request');
        const response = await get('/api.php/v1.video/category');
        if (response.data && response.data.code === 0) {
          this.courseCategories = response.data.data;
        } else {
          console.error('获取课程分类失败:', response.data?.msg || '未知错误');
        }
      } catch (error) {
        console.error('获取课程分类失败:', error);
      }
    },
    
    async startTest() {
      if (!this.allWatched) return
      
      try {
        // 1. 调用 /api.php/v1.exam/unlock?id= 接口
        const { get } = await import('@/common/request');
        const examResponse = await get(`/api.php/v1.exam/unlock?id=${this.currentCourse.cid}`)
        
        if (examResponse.data && examResponse.data.code === 0) {
          // 满足特殊格式 { code:0, data:{0:true,"msg":"视频重新上锁成功!"} }
          const apiData = examResponse.data.data;
          if (
            apiData &&
            apiData[0] === true &&
            apiData.msg === '视频重新上锁成功!'
          ) {
            // 弹窗提示三次考试未通过
            this.$alert(
              '三次考试未通过，请重新观看视频再来考试',
              '提示',
              {
                confirmButtonText: '确认',
                type: 'warning',
                callback: () => {
                  window.location.reload();
                }
              }
            )
            return;
          }

          const unlockMsg = apiData?.msg || ''
          // 检查是否超过考试次数
          if (unlockMsg && unlockMsg.includes('超过允许的考试次数')) {
            this.$message.error(unlockMsg)
            return
          }
          
          // 检查是否已经考试通过（兼容多种后端提示文案）
          if (
            unlockMsg && (
              unlockMsg.includes('已经考试通过') ||
              unlockMsg.includes('已经通过考试') ||
              unlockMsg.includes('你已经考试通过') ||
              unlockMsg.includes('你已经通过考试') ||
              unlockMsg.includes('已通过')
            )
          ) {
            this.$message.success(unlockMsg)
            return
          }
          
          const pid = examResponse.data.data.pid
          console.log('考试解锁成功，pid:', pid)
          
          // 2. 调用 /api.php/v1.paper/unlock?id= 接口
          const paperResponse = await get(`/api.php/v1.paper/unlock?id=${pid}`)
          
          if (paperResponse.data && paperResponse.data.code === 0) {
            console.log('试卷解锁成功')
            
            // 3. 获取课程分类ID
            const categoryId = await this.getCategoryIdForTest()
            
            if (categoryId) {
              console.log('开始测试，分类ID:', categoryId)
              
              // 4. 跳转到测试页面，传递分类ID
              this.$router.push({
                path: '/test',
                query: {
                  categoryId: categoryId,
                  courseName: this.currentCourse.name || this.currentCourse.level || '课程'
                }
              })
            } else {
              this.$message.error('无法获取课程分类ID')
            }
          } else {
            this.$message.error('试卷解锁失败: ' + (paperResponse.data?.msg || '未知错误'))
          }
        } else {
          this.$message.error('考试解锁失败: ' + (examResponse.data?.msg || '未知错误'))
        }
      } catch (error) {
        console.error('开始测试失败:', error)
        this.$message.error('开始测试失败，请重试')
      }
    },
    
    // 获取测试用的分类ID
    async getCategoryIdForTest() {
      // 先加载课程分类
      await this.loadCourseCategories()
      
      // 通过课程类型找到对应的分类ID
      if (this.courseType && this.courseType.startsWith('2-')) {
        const index = parseInt(this.courseType.split('-')[1]) - 1
        if (this.courseCategories[index]) {
          return this.courseCategories[index].id
        }
      }
      
      // 如果无法通过课程类型获取，尝试从currentCourse中获取
      if (this.currentCourse.cid) {
        return this.currentCourse.cid
      }
      
      // 最后尝试通过课程名称匹配
      if (this.currentCourse.name || this.currentCourse.level) {
        const courseName = this.currentCourse.name || this.currentCourse.level
        const category = this.courseCategories.find(cat => cat.name === courseName)
        if (category) {
          return category.id
        }
      }
      
      return null
    }
  }
}
</script>

<style scoped>
.course-content {
  padding: 20px;
}

.course-header {
  background: linear-gradient(135deg, #2a91ff 0%, #667eea 100%);
  border-radius: 16px;
  padding: 30px;
  color: white;
  margin-bottom: 30px;
  text-align: center;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 15px;
}

.level-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}

.level-icon {
  font-size: 36px;
  color: white;
}

.level-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}

.course-title {
  font-size: 2.2em;
  font-weight: bold;
  margin-bottom: 20px;
}

.course-level {
  font-size: 1.1em;
  color: #e0e0e0;
  margin-top: 5px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

.stats-cards {
  display: flex;
  gap: 20px;
}

.stat-card {
  text-align: center;
  color: white;
}

.stat-number {
  font-size: 2em;
  font-weight: bold;
  margin-bottom: 5px;
}

.stat-label {
  font-size: 1em;
  opacity: 0.8;
}

.video-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  margin-bottom: 40px;
}

.video-card {
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  border: 1px solid #e6f0ff;
}

.video-card:hover {
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.video-card-content {
  position: relative;
}

.video-thumb-container {
  position: relative;
  width: 100%;
  height: 180px;
  overflow: hidden;
}

.video-thumb {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(42, 145, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.3s ease;
}

.video-overlay i {
  font-size: 48px;
  color: white;
}

.video-thumb-container:hover .video-overlay {
  opacity: 1;
}

.video-thumb-container:hover .video-thumb {
  transform: scale(1.05);
}

.video-info {
  padding: 20px;
}

.video-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
  line-height: 1.4;
}

.video-meta {
  display: flex;
  align-items: center;
  gap: 15px;
  color: #666;
  font-size: 14px;
}

.duration {
  display: flex;
  align-items: center;
  gap: 5px;
}

.test-section {
  background: white;
  border-radius: 16px;
  padding: 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.test-header {
  text-align: center;
  margin-bottom: 30px;
}

.test-header h3 {
  font-size: 1.8em;
  color: #333;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.test-header h3 i {
  color: #2a91ff;
  font-size: 24px;
}

.test-header p {
  color: #666;
  font-size: 1.1em;
}

.exam-notice {
  background: #fff7e6;
  border: 1px solid #ffd591;
  border-radius: 8px;
  padding: 12px 16px;
  margin-top: 15px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #d46b08;
  font-size: 14px;
  line-height: 1.4;
}

.exam-notice i {
  color: #fa8c16;
  font-size: 16px;
  flex-shrink: 0;
}

.test-card {
  background: #f8f9ff;
  border-radius: 12px;
  padding: 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #e6f0ff;
  transition: all 0.3s ease;
}

.test-card:hover {
  border-color: #2a91ff;
  box-shadow: 0 4px 15px rgba(42, 145, 255, 0.1);
}

.test-info {
  display: flex;
  align-items: center;
  gap: 20px;
  flex: 1;
}

.test-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #2a91ff, #667eea);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: white;
}

.test-details h4 {
  font-size: 1.3em;
  color: #333;
  margin-bottom: 8px;
}

.test-details p {
  color: #666;
  margin-bottom: 12px;
}

.test-meta {
  display: flex;
  gap: 20px;
  font-size: 14px;
  color: #999;
}

.test-meta span {
  display: flex;
  align-items: center;
  gap: 5px;
}

.test-meta i {
  color: #2a91ff;
}

.video-locked {
  pointer-events: none;
}

.level-text {
  font-size: 2em;
  font-weight: bold;
  color: white;
  margin-top: 5px;
  margin-bottom: 0;
  line-height: 1.2;
}

  .loading-state {
    text-align: center;
    padding: 80px 20px;
    color: #666;
    background: white;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  }

  .loading-state i {
    font-size: 48px;
    color: #2a91ff;
    margin-bottom: 20px;
    display: block;
  }

  .loading-state p {
    font-size: 16px;
    margin: 0;
    color: #999;
  }

@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }

  .header-left {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .header-right {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }

  .stats-cards {
    flex-direction: column;
    gap: 10px;
  }

  .video-list {
    grid-template-columns: 1fr;
  }
  
  .test-card {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }
  
  .test-meta {
    justify-content: center;
  }
}
</style>
